<div id="mli-root"
     class="mli-loading"
     [attr.data-ptid]="meiliSecretKey"
     [attr.data-currency]="currencyCode"
     [attr.data-locale]="userLocale"
     [attr.data-query]="dataQuery"
></div>
